import { useIntl } from 'react-intl';
import { FOLDER_PICKER_ATTRIBUTES, type DiskImport } from '../hooks';

/**
 * The hidden inputs behind the folder and file pickers. Rendered once per dialog: the picker's refs
 * name a single input each, and every "choose" button in the dialog opens these.
 */
export default function DiskPickerInputs({
    picker,
}: {
    picker: DiskImport['picker'];
}) {
    const intl = useIntl();
    return (
        <>
            <input
                ref={picker.folderInputRef}
                type="file"
                multiple
                hidden
                onChange={picker.onPick}
                aria-label={intl.formatMessage({
                    id: 'patientList.import.dropzone.folderInputLabel',
                })}
                {...FOLDER_PICKER_ATTRIBUTES}
            />
            <input
                ref={picker.fileInputRef}
                type="file"
                multiple
                hidden
                onChange={picker.onPick}
                aria-label={intl.formatMessage({
                    id: 'patientList.import.dropzone.filesInputLabel',
                })}
            />
        </>
    );
}
